import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { edcUrls } from "../../URL/ApplicationUrls";
import { Edc } from "../Edc";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchEdc = (edcId: number | string | undefined) => {
  return useQuery<Edc, Error>({
    queryKey: namedQueryKeyWithId("edcs", edcId),
    queryFn: () => fetchEdc(edcId),
    onError: () => {
      toast.error(`An error occurred when retrieving the EDC with the Id ${edcId}`);
    },
  });
};

const fetchEdc = async (id: number | string | undefined) => {
  const { data: edc } = await axios.get<Edc>(edcUrls.mutateEdc(id).apiUrl);

  return edc;
};
